//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
class StrMap {
    constructor(dist) {
        this._sm = dist || {};
    }
    clear() {
        this._sm = {};
        return this;
    }
    set(k, v) {
        this._sm[k] = v;
        return this;
    }
    get(k) {
        return this._sm[k];
    }
    delete(k) {
        delete this._sm[k];
        return this;
    }
    has(k) {
        return this._sm[k] !== undefined;
    }

}
class SmartMap {
    constructor(dist) {
        this._wm = new WeakMap();
        this._sm = new StrMap(dist);
    }
    clear() {
        this._wm = new WeakMap();
        this._sm = new StrMap();
    }
    delete(k) {
        return this.smartMap(k).delete(k);
    }
    get(k) {
        return this.smartMap(k).get(k);
    }
    has(k) {
        return this.smartMap(k).has(k);
    }
    set(k, v) {
        this.smartMap(k).set(k, v);
        return this;
    }
    smartMap(k) {
        if (k instanceof Object) {
            return this._wm;
        } else {
            return this._sm;
        }
    }
}

module.exports = SmartMap;
